export function $$(query, container) {
    if (container === void 0) { container = document; }
    var list = container.querySelectorAll(query);
    return [].slice.call(list);
}
//# sourceMappingURL=$$.js.map